import {
  CategoriesResponse,
  GroupsResponse,
  IPartItemResponse,
  IntegrationsInfoResponse,
  PartTypeItem,
} from '../../../features/partsCatalog/Selections/interfaces'
import { IdValueGeneric } from 'interfaces'
import { PartsBasketCreds } from '../../../api/security/interfaces'
import { PartsCatalogAPI } from './PartsCatalogAPI'
import CatalogServiceProvider from '../../../services/CatalogServiceProvider'

export const defaultIntegrationInfo: IntegrationsInfoResponse = {
  epeFlag: true,
  allowAnyBuyer: false,
  authAttributesId: '',
  allowMultiSeller: false,
}

export class AstPunchOutCatalogAPI extends PartsCatalogAPI {
  constructor() {
    super()
    this.SESSION_STORAGE_KEY = 'selected-ast-catalog-tree'
  }

  fetchBrands = async (): Promise<Array<IdValueGeneric<string, string>>> => {
    const resp = await CatalogServiceProvider.fetchAstBrands()

    const brands = resp.data?.map((c): IdValueGeneric<string, string> => {
      return { id: c.value, value: c.label }
    })

    return brands
  }

  fetchCategories = async (): Promise<CategoriesResponse> => {
    const resp = await CatalogServiceProvider.fetchAstCategories()

    if (resp.status === 204) return null

    const categories = resp?.data?.map((c): IdValueGeneric<string, string> => {
      return { id: c.path, value: c.label }
    })

    return { categories, selectedCategories: [] }
  }

  fetchGroups = async (
    categories: Array<IdValueGeneric<string, string>>
  ): Promise<GroupsResponse> => {
    const groups = await Promise.all(
      categories.map((category) =>
        CatalogServiceProvider.fetchAstGroups(category.id).then((resp) => ({
          ...category,
          items: resp.data?.map(
            (g): PartTypeItem => ({
              id: g.path,
              value: g.label,
              isConsolidated: true,
            })
          ),
        }))
      )
    )

    return { groups, selectedGroups: [] }
  }

  fetchPartTypes = async (
    groups: Array<IdValueGeneric<string, string>>
  ): Promise<IPartItemResponse> => {
    const responses = await Promise.all(
      groups.map((group) =>
        CatalogServiceProvider.fetchAstTerminologies(group.id).then((resp) => ({
          ...group,
          items:
            resp.status === 204
              ? []
              : (resp.data?.map(
                  (pt): PartTypeItem => ({
                    id: pt.value,
                    value: pt.label,
                    isConsolidated: true,
                  })
                ) ?? []),
        }))
      )
    )

    return responses
  }

  fetchIntegrationsInfo = async (
    credentials: PartsBasketCreds
  ): Promise<IntegrationsInfoResponse> => {
    const parameters = {
      partnerId: credentials.partnerId,
      sellerId: credentials.sellerId,
      buyerId: credentials.buyerId,
    }

    try {
      const resp =
        await CatalogServiceProvider.fetchAstIntegrationInfo(parameters)

      if (resp?.status === 204) {
        return defaultIntegrationInfo
      }
      return resp?.data
    } catch (_e) {
      return defaultIntegrationInfo
    }
  }

  isGfxSupported = (): boolean => {
    return false
  }
}

export default new AstPunchOutCatalogAPI()
